import { fg } from '@atlaskit/platform-feature-flags';

import type { BaseObjectAttributes, FormButtonClickedAttributes } from '../../common';

interface GetBaseFormAnalyticsArgs {
	itemAti: FormButtonClickedAttributes['itemAti'];
	sourceProduct: FormButtonClickedAttributes['sourceProduct'];
	sourceSubProduct?: FormButtonClickedAttributes['sourceSubProduct'];
}

/**
 * Builds base analytics attributes for form control events.
 * Constructs an object with item analytics attribute information including the item ati, source product and source sub product.
 *
 * @param itemAti - The Atlassian Type Identifier for the item
 * @param sourceProduct - The product from which the form was initiated
 * @param sourceSubProduct - Optional sub product identifier
 * @returns {BaseObjectAttributes} Base analytics attributes object
 */
export const getBaseFormControlAnalyticsAttributes = ({
	itemAti,
	sourceProduct,
	sourceSubProduct,
}: GetBaseFormAnalyticsArgs): BaseObjectAttributes => ({
	itemAti,
	itemProduct: 'townsquare',
	...(fg('navx-3019-uc-form-events-analytics-subproduct')
		? { sourceProduct, sourceSubProduct }
		: {}),
});
